import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { NavArea, NavLayout } from '../components/Navigation'
import useScrollDirection, { UP } from '../hooks/useScrollDirection'
import Burger from './Hamburger.module.scss'
import CSS from './Layout.module.scss'
import LayoutBase from './LayoutBase'
import MainNavigation from './MainNavigation'
import TopNav from './TopNav'

/**
 * Layout
 */

const Layout = (props: Props) => {
  const { children, compact } = props
  const [isMenuVisible, setMenuVisible] = useState(false)
  const toggleMenuVisible = () => setMenuVisible(state => !state)

  // Disable menu when navigating (ie, page `path` changes)
  useEffect(() => {
    setMenuVisible(false)
  }, [props.path || ''])

  const { direction: scrollDir } = useScrollDirection()

  return (
    <LayoutBase>
      <NavLayout
        navProps={{ noLogotype: true, noMonogram: true, externalLinks: true }}
      >
        <NavArea light>
          <div className={CSS.root}>
            {/* Navigation */}
            <div className={CSS.nav}>
              <TopNav compact={compact} />
            </div>

            <div className={CSS.body}>{children}</div>

            {/* TOC sidebar */}
            <aside>
              {/* Menu button toggle */}
              <button
                onClick={toggleMenuVisible}
                className={cn(CSS.tocToggle, {
                  [CSS.isHidden]: scrollDir !== UP,
                  [CSS.isMenuVisible]: isMenuVisible
                })}
              >
                {/* Burger */}
                <div
                  className={cn(Burger.hamburger, Burger.hamburgerCollapse, {
                    [Burger.isActive]: isMenuVisible
                  })}
                >
                  <div className={Burger.hamburgerBox}>
                    <div className={Burger.hamburgerInner} />
                  </div>
                </div>
              </button>

              <div
                className={cn(CSS.toc, { [CSS.isMenuVisible]: isMenuVisible })}
              >
                <MainNavigation />
              </div>
            </aside>
          </div>
        </NavArea>
      </NavLayout>
    </LayoutBase>
  )
}

interface Props {
  children: React.ReactNode
  compact: boolean
  path?: string
}

Layout.defaultProps = {
  compact: false,
  path: ''
}

export default Layout
